import { ReactNode } from "react";
import { styles } from "./IframeContainer.style";

interface Props {
  children: ReactNode;
}

const IframeContainer: React.FC<Props> = (props) => {
  const { children } = props;

  return (
    <div className={styles.iframeWrapper()}>
      <>{children}</>
    </div>
  );
};

export default IframeContainer;
